'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var MuiCircularProgress = require('@mui/material/CircularProgress');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MuiCircularProgress__default = /*#__PURE__*/_interopDefaultLegacy(MuiCircularProgress);

var CircularProgress = function (_props) {
    return (React__default["default"].createElement(MuiCircularProgress__default["default"], { "aria-label": "loading-spinner" }));
};

exports["default"] = CircularProgress;
